// ─────────────────────────────────────────────────────────────────────────────
// Datos de prueba — Pereira, Risaralda, Colombia
// Se reemplazarán por datos reales de Supabase
// ─────────────────────────────────────────────────────────────────────────────

export const STRIPE = (a: string, b: string) =>
  `repeating-linear-gradient(135deg,${a} 0 14px,${b} 14px 28px)`

export type BizData = {
  id: string
  name: string
  cat: string
  zone: string
  verified: boolean
  followers: number
  dist: string
  open: boolean
  price: string
  cover: [string, string]
  emoji: string
  desc: string
  x: number
  y: number
  type: string
}

export const BIZ: BizData[] = [
  {
    id: 'b1',
    name: 'La Terraza Circunvalar',
    cat: 'Rooftop / Bar',
    zone: 'Circunvalar',
    verified: true,
    followers: 3820,
    dist: '0.8 km',
    open: true,
    price: '$$',
    cover: ['#0F5C5C', '#17706f'],
    emoji: '🌆',
    desc: 'El rooftop más icónico de Pereira con vista a la ciudad. Coctelería artesanal y DJ sets los fines de semana.',
    x: 48,
    y: 28,
    type: 'live',
  },
  {
    id: 'b2',
    name: 'El Rincón Paisa',
    cat: 'Restaurante típico',
    zone: 'Centro',
    verified: true,
    followers: 2910,
    dist: '1.2 km',
    open: true,
    price: '$',
    cover: ['#D9785B', '#E28B70'],
    emoji: '🍲',
    desc: 'Bandeja paisa, sancocho y mazamorra en el corazón de Pereira. Sabor casero desde 1998.',
    x: 38,
    y: 42,
    type: 'promo',
  },
  {
    id: 'b3',
    name: 'Café Quindío Pereira',
    cat: 'Café de especialidad',
    zone: 'Pinares',
    verified: true,
    followers: 1850,
    dist: '2.1 km',
    open: true,
    price: '$$',
    cover: ['#D3A34A', '#dcb968'],
    emoji: '☕',
    desc: 'Café de origen del Eje Cafetero, métodos de filtrado y repostería artesanal.',
    x: 62,
    y: 36,
    type: 'new',
  },
  {
    id: 'b4',
    name: 'Gastropub La Badea',
    cat: 'Gastropub',
    zone: 'Circunvalar',
    verified: true,
    followers: 4140,
    dist: '1.0 km',
    open: true,
    price: '$$',
    cover: ['#153D3D', '#0F5C5C'],
    emoji: '🍺',
    desc: 'Cervezas artesanales del Eje, cocina de mercado y terraza con vista a la cordillera.',
    x: 52,
    y: 30,
    type: 'promo',
  },
  {
    id: 'b5',
    name: 'Club Soho',
    cat: 'Discoteca / Club',
    zone: 'Álamos',
    verified: true,
    followers: 7200,
    dist: '2.4 km',
    open: true,
    price: '$$$',
    cover: ['#1d2440', '#0F5C5C'],
    emoji: '💿',
    desc: 'El club más popular de Pereira. Electrónica, reggaetón y salsa en una sola noche.',
    x: 30,
    y: 50,
    type: 'event',
  },
  {
    id: 'b6',
    name: 'La Fogata Cerritos',
    cat: 'Restaurante campestre',
    zone: 'Cerritos',
    verified: true,
    followers: 3280,
    dist: '4.5 km',
    open: true,
    price: '$$',
    cover: ['#D9785B', '#D3A34A'],
    emoji: '🔥',
    desc: 'Asados, chorizos y lechona en el corredor gastronómico de Cerritos. Ambiente familiar.',
    x: 78,
    y: 60,
    type: 'promo',
  },
  {
    id: 'b7',
    name: 'Museo de Arte de Pereira',
    cat: 'Galería / Cultura',
    zone: 'Centro',
    verified: true,
    followers: 1120,
    dist: '1.5 km',
    open: true,
    price: '$',
    cover: ['#153D3D', '#3a4a4a'],
    emoji: '🖼️',
    desc: 'Arte contemporáneo colombiano, exposiciones temporales y talleres creativos.',
    x: 36,
    y: 40,
    type: 'free',
  },
  {
    id: 'b8',
    name: 'Estudio Alma',
    cat: 'Centro de bienestar',
    zone: 'Pinares',
    verified: true,
    followers: 1560,
    dist: '2.3 km',
    open: true,
    price: '$$',
    cover: ['#D3A34A', '#D9785B'],
    emoji: '🧘',
    desc: 'Yoga, meditación, talleres de mindfulness y masajes terapéuticos.',
    x: 64,
    y: 32,
    type: 'experience',
  },
  {
    id: 'b9',
    name: 'La Republica Café',
    cat: 'Café cultural',
    zone: 'Centro',
    verified: false,
    followers: 680,
    dist: '0.9 km',
    open: true,
    price: '$',
    cover: ['#6D7471', '#8a918e'],
    emoji: '📚',
    desc: 'Café literario, coworking y eventos culturales en el centro histórico.',
    x: 40,
    y: 44,
    type: 'new',
  },
  {
    id: 'b10',
    name: 'Teatro Santiago Londoño',
    cat: 'Espacio cultural',
    zone: 'Centro',
    verified: true,
    followers: 2040,
    dist: '1.1 km',
    open: true,
    price: '$',
    cover: ['#0F5C5C', '#153D3D'],
    emoji: '🎭',
    desc: 'Teatro, danza folclórica y conciertos de música tradicional cafetera.',
    x: 42,
    y: 46,
    type: 'event',
  },
  {
    id: 'b11',
    name: 'Nikkei Pereira',
    cat: 'Restaurante asiático',
    zone: 'Pinares',
    verified: true,
    followers: 3600,
    dist: '2.8 km',
    open: true,
    price: '$$$',
    cover: ['#3a2a3a', '#D9785B'],
    emoji: '🍱',
    desc: 'Cocina nikkei y fusión japonesa-peruana en el sector más gourmet de Pereira.',
    x: 66,
    y: 34,
    type: 'promo',
  },
  {
    id: 'b12',
    name: 'Jazz & Son Café',
    cat: 'Bar de música en vivo',
    zone: 'Circunvalar',
    verified: true,
    followers: 2980,
    dist: '1.3 km',
    open: true,
    price: '$$',
    cover: ['#2a2440', '#0F5C5C'],
    emoji: '🎷',
    desc: 'Jazz, blues y música en vivo todas las noches. El mejor ambiente para conversar.',
    x: 50,
    y: 26,
    type: 'live',
  },
  {
    id: 'b13',
    name: 'Parque Ukumari',
    cat: 'Parque / Aire libre',
    zone: 'La Victoria',
    verified: true,
    followers: 5420,
    dist: '5.0 km',
    open: true,
    price: '$$',
    cover: ['#3E8B63', '#0F5C5C'],
    emoji: '🦁',
    desc: 'Bioparque y zoológico, planes al aire libre con la familia en las afueras de Pereira.',
    x: 20,
    y: 70,
    type: 'free',
  },
  {
    id: 'b14',
    name: 'La Casona del Café',
    cat: 'Restaurante familiar',
    zone: 'Dosquebradas',
    verified: true,
    followers: 1340,
    dist: '3.8 km',
    open: true,
    price: '$$',
    cover: ['#D3A34A', '#3E8B63'],
    emoji: '🏡',
    desc: 'Cocina campesina del Eje Cafetero, desayunos típicos y almuerzo en finca cafetera.',
    x: 72,
    y: 54,
    type: 'experience',
  },
  {
    id: 'b15',
    name: 'Cervecería Risaralda',
    cat: 'Cervecería artesanal',
    zone: 'Álamos',
    verified: true,
    followers: 2860,
    dist: '2.0 km',
    open: true,
    price: '$$',
    cover: ['#7a5a2a', '#D3A34A'],
    emoji: '🍻',
    desc: 'Cervezas artesanales inspiradas en el paisaje cafetero. Tapas y música en vivo los jueves.',
    x: 32,
    y: 48,
    type: 'promo',
  },
]
export const getBiz = (id: string) => BIZ.find((b) => b.id === id)

export type PostData = {
  id: string
  biz: string
  type: string
  title: string
  img: [string, string]
  desc: string
  cat: string
  date?: string
  start?: string
  price?: string
  age?: string
  dress?: string
  time?: string
  ends?: string
  endsMin?: number
  cond?: string
  interested: number
  mood?: string
  occ?: string
  updated?: string
  dur?: string
  level?: string
  includes?: string
  open?: string
  // Campos opcionales de Supabase (cuando el negocio no está en mockData)
  bizName?: string
  bizZone?: string
  bizEmoji?: string
  bizVerified?: boolean
  bizDist?: string
}

export const POSTS: PostData[] = [
  {
    id: 'p1',
    biz: 'b2',
    type: 'promo',
    title: 'Almuerzo ejecutivo + jugo por $15.000',
    img: ['#D9785B', '#E28B70'],
    desc: 'Bandeja paisa completa, sopa del día y jugo natural a precio especial. De lunes a viernes hasta las 3 p. m.',
    cat: 'comer',
    time: 'Activa',
    ends: '3:00 p. m.',
    endsMin: 90,
    cond: 'Solo en plato del día. No aplica domingos.',
    interested: 187,
  },
  {
    id: 'p2',
    biz: 'b1',
    type: 'live',
    title: 'Noche de DJ en La Terraza',
    img: ['#0F5C5C', '#17706f'],
    desc: 'Música electrónica y el mejor ambiente de la Circunvalar con vista a toda Pereira.',
    cat: 'bailar',
    mood: 'Muy animado',
    occ: 'Alta',
    updated: 'hace 3 min',
    interested: 412,
  },
  {
    id: 'p3',
    biz: 'b12',
    type: 'live',
    title: 'Jazz en vivo — ya empezó',
    img: ['#2a2440', '#0F5C5C'],
    desc: 'Trío de jazz en vivo. Ambiente íntimo, buen whisky y la mejor música de la ciudad.',
    cat: 'musica',
    mood: 'Animado',
    occ: 'Media',
    updated: 'hace 8 min',
    interested: 94,
  },
  {
    id: 'p4',
    biz: 'b8',
    type: 'experience',
    title: 'Taller de yoga y meditación',
    img: ['#D3A34A', '#D9785B'],
    desc: 'Sesión de 2 horas de yoga y meditación guiada. Incluye té de hierbas del Eje Cafetero.',
    cat: 'exp',
    date: 'Sábado',
    start: '8:00 a. m.',
    dur: '2 horas',
    price: '$45.000',
    level: 'Todos los niveles',
    includes: 'Colchoneta, té y guía',
    interested: 68,
  },
  {
    id: 'p5',
    biz: 'b4',
    type: 'promo',
    title: '2x1 en cervezas artesanales',
    img: ['#153D3D', '#0F5C5C'],
    desc: '2x1 en todas las cervezas de la casa. Aplica en barra y terraza. Hoy solo.',
    cat: 'beber',
    time: 'Activa',
    ends: '9:00 p. m.',
    endsMin: 140,
    cond: 'Solo en cervezas de la casa.',
    interested: 156,
  },
  {
    id: 'p6',
    biz: 'b7',
    type: 'free',
    title: 'Exposición: Arte del Eje Cafetero',
    img: ['#153D3D', '#3a4a4a'],
    desc: 'Pinturas y fotografías de artistas de Pereira, Armenia y Manizales. Entrada libre.',
    cat: 'cultura',
    date: 'Hoy',
    start: 'Hasta 7:00 p. m.',
    price: 'Gratis',
    interested: 89,
  },
  {
    id: 'p7',
    biz: 'b5',
    type: 'event',
    title: 'Noche de reggaetón — Urban Night',
    img: ['#1d2440', '#0F5C5C'],
    desc: 'Los mejores DJs de la escena urbana de Pereira. Boletería anticipada agotada — quedan en puerta.',
    cat: 'bailar',
    date: 'Hoy',
    start: '10:00 p. m.',
    price: '$30.000 en puerta',
    age: '+18',
    dress: 'Casual elegante',
    interested: 534,
  },
  {
    id: 'p8',
    biz: 'b3',
    type: 'new',
    title: 'Nuevo café de especialidad en Pinares',
    img: ['#D3A34A', '#dcb968'],
    desc: 'Abrimos con café de origen de la Sierra Nevada, métodos de filtrado y tortas artesanales.',
    cat: 'comer',
    open: 'Abierto esta semana',
    interested: 142,
  },
  {
    id: 'p9',
    biz: 'b10',
    type: 'event',
    title: 'Noche de folclor cafetero',
    img: ['#0F5C5C', '#153D3D'],
    desc: 'Música de cuerda, bambucos y pasillos en vivo. Entrada libre con cupo limitado.',
    cat: 'musica',
    date: 'Viernes',
    start: '7:00 p. m.',
    price: 'Gratis',
    interested: 178,
  },
  {
    id: 'p10',
    biz: 'b13',
    type: 'free',
    title: 'Festival de Aves en Ukumari',
    img: ['#3E8B63', '#0F5C5C'],
    desc: 'Avistamiento de aves endémicas del Eje Cafetero. Guías certificados incluidos.',
    cat: 'aire',
    date: 'Domingo',
    start: '7:00 a. m.',
    price: 'Gratis con boleto de entrada',
    interested: 310,
  },
  {
    id: 'p11',
    biz: 'b15',
    type: 'promo',
    title: 'Flight de 4 cervezas — $25.000',
    img: ['#7a5a2a', '#D3A34A'],
    desc: 'Prueba las 4 cervezas artesanales de la casa por $25.000. Solo hoy.',
    cat: 'beber',
    time: 'Activa',
    ends: '8:00 p. m.',
    endsMin: 45,
    cond: 'Un flight por persona.',
    interested: 98,
  },
  {
    id: 'p12',
    biz: 'b6',
    type: 'promo',
    title: 'Asado familiar los domingos',
    img: ['#D9785B', '#D3A34A'],
    desc: 'Lechona, chorizos y empanadas para toda la familia en Cerritos. Ambiente campestre.',
    cat: 'comer',
    date: 'Domingo',
    start: '11:00 a. m.',
    price: 'Desde $35.000',
    interested: 267,
  },
  {
    id: 'p13',
    biz: 'b1',
    type: 'promo',
    title: 'Happy hour 5-8 p. m. — todo 2x1',
    img: ['#0F5C5C', '#17706f'],
    desc: 'Todos los cocteles y cervezas 2x1 en la terraza con puesta de sol sobre Pereira.',
    cat: 'beber',
    time: 'Activa',
    ends: '8:00 p. m.',
    endsMin: 110,
    cond: 'Solo en barra y terraza exterior.',
    interested: 223,
  },
  {
    id: 'p14',
    biz: 'b9',
    type: 'social',
    title: 'Encuentro de emprendedores creativos',
    img: ['#6D7471', '#8a918e'],
    desc: 'Red de jóvenes creativos de Pereira. Networking, pitches y café de por medio.',
    cat: 'social',
    date: 'Jueves',
    start: '6:00 p. m.',
    price: '$10.000 (incluye café)',
    age: '+18',
    interested: 73,
  },
  {
    id: 'p15',
    biz: 'b11',
    type: 'promo',
    title: 'Menú omakase por $80.000',
    img: ['#3a2a3a', '#D9785B'],
    desc: 'Experiencia omakase de 8 tiempos con el chef. Cupos muy limitados — reserva requerida.',
    cat: 'comer',
    time: 'Activa',
    ends: '9:30 p. m.',
    endsMin: 175,
    interested: 118,
  },
  {
    id: 'p16',
    biz: 'b14',
    type: 'experience',
    title: 'Tour cafetero + desayuno en finca',
    img: ['#D3A34A', '#3E8B63'],
    desc: 'Recorrido por proceso del café, cosecha en finca y desayuno típico cafetero incluido.',
    cat: 'exp',
    date: 'Sábado',
    start: '7:00 a. m.',
    dur: '3 horas',
    price: '$55.000',
    level: 'Para todos',
    includes: 'Transporte, guía y desayuno',
    interested: 196,
  },
  {
    id: 'p17',
    biz: 'b15',
    type: 'live',
    title: 'Trovadores en vivo esta noche',
    img: ['#7a5a2a', '#D3A34A'],
    desc: 'Música de trova y parranda cafetera en directo, acompañada de las cervezas artesanales de la casa.',
    cat: 'musica',
    mood: 'Animado',
    occ: 'Media',
    updated: 'hace 12 min',
    interested: 132,
  },
  {
    id: 'p18',
    biz: 'b5',
    type: 'live',
    title: 'DJ set en vivo — pista abierta',
    img: ['#1d2440', '#0F5C5C'],
    desc: 'Set de electrónica y reggaetón en vivo, pista abierta desde temprano.',
    cat: 'bailar',
    mood: 'Muy animado',
    occ: 'Alta',
    updated: 'hace 5 min',
    interested: 289,
  },
  {
    id: 'p19',
    biz: 'b9',
    type: 'event',
    title: 'Recital de poesía y música acústica',
    img: ['#6D7471', '#8a918e'],
    desc: 'Poetas locales y música acústica en el café literario del centro histórico.',
    cat: 'cultura',
    date: 'Miércoles',
    start: '7:00 p. m.',
    price: 'Entrada libre',
    interested: 56,
  },
  {
    id: 'p20',
    biz: 'b6',
    type: 'event',
    title: 'Parranda vallenata en vivo',
    img: ['#D9785B', '#D3A34A'],
    desc: 'Conjunto vallenato en vivo con cena campestre en el corredor de Cerritos.',
    cat: 'musica',
    date: 'Sábado',
    start: '8:00 p. m.',
    price: '$40.000 con cena',
    interested: 145,
  },
]
export const getPost = (id: string) => POSTS.find((p) => p.id === id)

export const CATS = [
  { k: 'comer', label: 'Comer', emoji: '🍽️' },
  { k: 'beber', label: 'Beber', emoji: '🍺' },
  { k: 'bailar', label: 'Bailar', emoji: '💃' },
  { k: 'musica', label: 'Música', emoji: '🎵' },
  { k: 'cultura', label: 'Cultura', emoji: '🎭' },
  { k: 'exp', label: 'Experiencias', emoji: '✨' },
  { k: 'aire', label: 'Aire libre', emoji: '🌿' },
  { k: 'familia', label: 'Familia', emoji: '👨‍👩‍👧' },
  { k: 'social', label: 'Socializar', emoji: '🤝' },
  { k: 'gratis', label: 'Gratis', emoji: '🎁' },
  { k: 'cafe', label: 'Café', emoji: '☕' },
  { k: 'desc', label: 'Descuentos', emoji: '🏷️' },
]

export const STORIES = [
  { id: 's1', cat: 'En vivo', biz: 'b1', color: '#D85F5F' },
  { id: 's2', cat: 'Esta noche', biz: 'b5', color: '#0F5C5C' },
  { id: 's3', cat: 'Promos', biz: 'b4', color: '#D9785B' },
  { id: 's4', cat: 'Café & Brunch', biz: 'b3', color: '#D3A34A' },
  { id: 's5', cat: 'Música', biz: 'b12', color: '#0F5C5C' },
  { id: 's6', cat: 'Terraza', biz: 'b1', color: '#D9785B' },
  { id: 's7', cat: 'Cultural', biz: 'b10', color: '#0F5C5C' },
  { id: 's8', cat: 'Fin de semana', biz: 'b6', color: '#D3A34A' },
]

export const TRENDS = [
  { tag: 'Circunvalar', n: 214 },
  { tag: 'Brunch cafetero', n: 142 },
  { tag: 'Jazz en vivo', n: 98 },
  { tag: 'Cervezas', n: 187 },
  { tag: 'Planes gratis', n: 156 },
  { tag: 'Cerritos', n: 122 },
  { tag: 'Networking', n: 67 },
  { tag: 'Cultura', n: 89 },
]

export const ZONES = [
  'Circunvalar',
  'Centro',
  'Pinares',
  'Álamos',
  'Cerritos',
  'Cuba',
  'Dosquebradas',
  'La Victoria',
  'El Jardín',
  'Belmonte',
  'Santa Mónica',
  'El Poblado',
  'Nacederos',
  'Kennedy',
  'Villa del Prado',
]

export const TYPE_META: Record<string, { label: string; color: string }> = {
  live: { label: 'EN VIVO', color: '#D85F5F' },
  promo: { label: 'Promoción', color: '#D9785B' },
  event: { label: 'Evento', color: '#0F5C5C' },
  experience: { label: 'Experiencia', color: '#D3A34A' },
  free: { label: 'Gratis', color: '#3E8B63' },
  social: { label: 'Social', color: '#0F5C5C' },
  new: { label: 'Nuevo lugar', color: '#D3A34A' },
}
